var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { OptionLabel, Option } from "./components";
var SingleBarChart = function (_a) {
    var options = _a.options;
    if (!(options === null || options === void 0 ? void 0 : options.length)) {
        return null;
    }
    var total = options.reduce(function (a, b) { return a + b.value; }, 0);
    return (_jsxs(Stack, { children: [_jsx(Stack, __assign({ direction: "row", gap: "2px", mb: 5 }, { children: options.map(function (option, i) { return (_jsx(Option, { color: option.color, width: total
                        ? "".concat((option.value / total) * 100, "%")
                        : "".concat(100 / options.length, "%"), first: i === 0, last: i + 1 === options.length }, option.label)); }) })), _jsx(Stack, __assign({ direction: "row", justifyContent: "space-between" }, { children: options.map(function (option) { return (_jsx(OptionLabel, { color: option.color, label: option.label, value: option.value, total: total }, option.label)); }) }))] }));
};
export default SingleBarChart;
